/**
 * Sentry doit être initialisé AVANT tout autre code.
 * Ce fichier est importé en premier dans index.tsx.
 */
import * as Sentry from "@sentry/react";
import axios from "axios";

const getSentryEnvironment = () => {
  const mode = process.env.REACT_APP_MODE;
  switch (mode) {
    case "DEV":
      return "development";
    case "PROD":
      return "production";
    case "STAGING":
      return "staging";
    default:
      return "development";
  }
};

const environment = getSentryEnvironment();
const isProduction = environment === "production";

// URLs pour la propagation des traces (frontend → backend) - essentiel pour le tracing distribué
const apiUrl = process.env.REACT_APP_URL_BACKEND || "";
const traceTargets: (string | RegExp)[] = [
  "localhost",
  /^https?:\/\/localhost(:\d+)?/,
  /^https?:\/\/127\.0\.0\.1(:\d+)?/,
];
if (apiUrl) {
  try {
    const url = new URL(apiUrl);
    traceTargets.push(url.origin);
    traceTargets.push(new RegExp(`^https?:\\/\\/${url.hostname}(:\\d+)?`));
  } catch {
    traceTargets.push(apiUrl);
  }
}

Sentry.init({
  dsn:
    process.env.REACT_APP_SENTRY_DSN ||
    "https://606672e713bd266870e96301683c8986@sentry.mjb.ovh/27",
  sendDefaultPii: true,
  environment,
  enabled: true,
  release: process.env.REACT_APP_SENTRY_RELEASE,
  tracesSampleRate: isProduction ? 0.1 : 1.0,
  replaysSessionSampleRate: isProduction ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: traceTargets,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      mask: ["input[type='password']", "[data-sensitive]"],
    }),
  ],
});

// Intercepteur Axios : envoie les erreurs API à Sentry
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status !== 401 && (status >= 500 || status === 0 || status == null)) {
      Sentry.captureException(error, {
        extra: {
          url: error.config?.url,
          method: error.config?.method,
          status,
        },
      });
    }
    return Promise.reject(error);
  }
);
